import React, { useState } from 'react';
import './ToolPage.css';

const HexConverter = () => {
  const [decimal, setDecimal] = useState('');
  const [hex, setHex] = useState('');
  const [binary, setBinary] = useState('');
  const [ascii, setAscii] = useState('');

  const updateFromDecimal = (value) => {
    setDecimal(value);
    if (value === '' || isNaN(value)) {
      setHex('');
      setBinary('');
      setAscii('');
      return;
    }
    const num = parseInt(value, 10);
    setHex(num.toString(16).toUpperCase());
    setBinary(num.toString(2));
    setAscii(num >= 32 && num <= 126 ? String.fromCharCode(num) : '');
  };

  const updateFromHex = (value) => {
    setHex(value.toUpperCase());
    if (value === '' || !/^[0-9A-Fa-f]+$/.test(value)) {
      setDecimal('');
      setBinary('');
      setAscii('');
      return;
    }
    const num = parseInt(value, 16);
    setDecimal(num.toString());
    setBinary(num.toString(2));
    setAscii(num >= 32 && num <= 126 ? String.fromCharCode(num) : '');
  };

  const updateFromBinary = (value) => {
    setBinary(value);
    if (value === '' || !/^[01]+$/.test(value)) {
      setDecimal('');
      setHex('');
      setAscii('');
      return;
    }
    const num = parseInt(value, 2);
    setDecimal(num.toString());
    setHex(num.toString(16).toUpperCase());
    setAscii(num >= 32 && num <= 126 ? String.fromCharCode(num) : '');
  };

  const clearAll = () => {
    setDecimal('');
    setHex('');
    setBinary('');
    setAscii('');
  };

  return (
    <div className="tool-page">
      <div className="tool-header">
        <h1 className="tool-title">Hex Converter</h1>
        <p className="tool-description">
          Convert between hexadecimal, decimal, binary, and ASCII formats
        </p>
      </div>

      <div className="tool-content">
        <div className="converter-grid">
          <div className="input-group">
            <label className="input-label">Decimal</label>
            <input
              type="text"
              className="input-field"
              value={decimal}
              onChange={(e) => updateFromDecimal(e.target.value)}
              placeholder="Enter decimal number"
            />
          </div>

          <div className="input-group">
            <label className="input-label">Hexadecimal</label>
            <input
              type="text"
              className="input-field"
              value={hex}
              onChange={(e) => updateFromHex(e.target.value)}
              placeholder="Enter hex value"
            />
          </div>

          <div className="input-group">
            <label className="input-label">Binary</label>
            <input
              type="text"
              className="input-field"
              value={binary}
              onChange={(e) => updateFromBinary(e.target.value)}
              placeholder="Enter binary number"
            />
          </div>

          <div className="input-group">
            <label className="input-label">ASCII Character</label>
            <input
              type="text"
              className="input-field"
              value={ascii}
              readOnly
              placeholder="ASCII output"
            />
          </div>
        </div>

        <button className="clear-btn" onClick={clearAll}>
          Clear All
        </button>
      </div>
    </div>
  );
};

export default HexConverter;
